export const inventoryFaqs = [
  {
    question: "What does the RFID inventory system track?",
    answer:
      "Each item is tagged with a UHF RFID chip. Smart cabinets and handheld readers register every check-in and check-out, giving you live counts, location data, and automated low-stock alerts.",
  },
  {
    question: "How does automated replenishment work?",
    answer:
      "When stock drops below a threshold you configure, MF's platform generates a replenishment order automatically and submits it for approval — no manual counting or reordering.",
  },
  {
    question: "Can this integrate with my existing ERP?",
    answer:
      "Yes, via the MF Enterprise Programme — Punchout integration with most common ERPs is supported. Inventory data and replenishment orders flow directly into your procurement workflow.",
  },
  {
    question: "What kinds of items can I track?",
    answer:
      "Any item we supply — uniforms, scrubs, lab coats, PPE, linens, towels, accessories, and other consumables. If MF supplies it, MF can RFID-track it.",
  },
];
